
import { LOAD_UTILIZATION_SUCCESS, CLEAR_UTILIZATION } from "../actions/ActionTypes";

// Assuming this is your initial state - adjust based on your actual structure
const initialState = {
  utilization: 0,
  billableTime: 0,
  nonQualifiedBillableHours: 0,
  requiredTime: 0,
  possibleHours: 0,
  pto: 0,
  potentialRevShareHours: 0
  // Add any other default properties needed
};

export default function utilizationReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_UTILIZATION_SUCCESS:
      return action.payload || initialState;
    case CLEAR_UTILIZATION:
      return initialState; // Reset to default empty state
    default:
      return state;
  }
}
